module.exports = __webpack_public_path__ + "img/paid-hero.5138f796.png";